var _mask, _path, _mask2, _rect, _mask3, _rect2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWaterBattery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_257_9151",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 18C3 19.1046 3.89543 20 5 20H7C8.10457 20 9 19.1046 9 18V16.01C9 16.0045 9.00448 16 9.01 16H19C20.1046 16 21 15.1046 21 14V12C21 10.8954 20.1046 10 19 10H7H6H5C3.89543 10 3 10.8954 3 12V18Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 18H5H1C1 20.2091 2.79086 22 5 22V18ZM7 18H5V22H7V18ZM7 18V22C9.20914 22 11 20.2091 11 18H7ZM7 16.01V18H11V16.01H7ZM19 14H9.01V18H19V14ZM19 14V18C21.2091 18 23 16.2091 23 14H19ZM19 12V14H23V12H19ZM19 12H23C23 9.79086 21.2091 8 19 8V12ZM7 12H19V8H7V12ZM6 12H7V8H6V12ZM5 12H6V8H5V12ZM5 12V12V8C2.79086 8 1 9.79086 1 12H5ZM5 18V12H1V18H5ZM11 16.01C11 17.1092 10.1089 18 9.01 18V14C7.90003 14 7 14.8998 7 16.01H11Z",
    fill: "black",
    mask: "url(#path-2-inside-1_257_9151)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-2_257_9151",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 7,
    width: 4,
    height: 5,
    rx: 1
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 7,
    width: 4,
    height: 5,
    rx: 1,
    strokeWidth: 4,
    mask: "url(#path-4-inside-2_257_9151)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-3_257_9151",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 4,
    width: 8,
    height: 5,
    rx: 1
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 4,
    width: 8,
    height: 5,
    rx: 1,
    strokeWidth: 4,
    mask: "url(#path-5-inside-3_257_9151)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterBattery);
export default __webpack_public_path__ + "static/media/WaterBattery.673a9413698912e0936331ccb5a5dedd.svg";
export { ForwardRef as ReactComponent };